import {useMutation} from '@apollo/react-hooks';

import type {
    FormNextStepsNutshellNotificationDelete as FormNextStepsNutshellNotificationDeleteMutation,
    FormNextStepsNutshellNotificationDeleteVariables as FormNextStepsNutshellNotificationDeleteMutationVariables,
} from 'nutshell-graphql-types';

import NEXT_STEPS_NUTSHELL_NOTIFICATION_DELETE from '../mutations/delete-next-steps-nutshell-notification.graphql';

export function useDeleteNextStepsNutshellNotification(): (arg1: {
    variables: FormNextStepsNutshellNotificationDeleteMutationVariables;
    onUpdateSuccess: (client?: any) => void;
}) => Promise<any> {
    const [deleteNextStepsNutshellNotification] = useMutation<
        FormNextStepsNutshellNotificationDeleteMutation,
        FormNextStepsNutshellNotificationDeleteMutationVariables
    >(NEXT_STEPS_NUTSHELL_NOTIFICATION_DELETE);

    return (input: {
        variables: FormNextStepsNutshellNotificationDeleteMutationVariables;
        onUpdateSuccess: (client?: any) => void;
    }) => {
        return deleteNextStepsNutshellNotification({
            variables: input.variables,
            update: (proxy) => {
                input.onUpdateSuccess(proxy);
            },
        });
    };
}
